import { createStore } from '../.'

import type { StateStorage } from 'zustand/middleware'
import type { Contact } from '../../interfaces/common'

interface UserContactStore {
  contacts: Contact[]
  setContacts: (contacts: Contact[]) => void
  getContactByAddress: (address: string) => Contact | undefined
  addContact: (attrs: Contact) => void
  updateContact: (address: string, attrs: Partial<Contact>) => void
  removeContact: (contact: Contact) => void
}

export const createContactsStore = (storage: StateStorage) =>
  createStore<UserContactStore>(
    storage,
    (set, get) => ({
      contacts: [],
      setContacts: (contacts: Contact[]) => {
        set({ contacts })
      },
      getContactByAddress(address) {
        const { contacts } = get()

        return contacts.find((c) => c.address.toLowerCase() === address.toLowerCase())
      },
      addContact(contact) {
        set(({ contacts }) => ({ contacts: [...contacts, contact] }))
      },
      updateContact(address, attrs) {
        set(({ contacts }) => ({
          contacts: contacts
            .map((c) => {
              if (c.address === address) {
                return { ...c, ...attrs }
              } else if (c.address !== attrs.address) {
                return c
              }
            })
            .filter((c) => !!c),
        }))
      },
      removeContact(contact) {
        const { contacts } = get()
        set({ contacts: contacts.filter((c) => c.address !== contact.address) })
      },
    }),
    {
      persist: {
        name: 'plug.contacts.user',
      },
    }
  )
